// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_af-3";
export var contentContainer = "_af-0";
export var editorContainer = "_af-1";
export var quillInputForm = "_af-2";
export var zoneDivider = "_af-4";